export const ZoomInIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_22_1322)">
      <circle cx="10" cy="10" r="7" stroke="#427783" strokeWidth="2" />
      <line
        x1="15.4142"
        y1="16"
        x2="18.25"
        y2="18.8358"
        stroke="#427783"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line x1="6" y1="10" x2="14" y2="10" stroke="#427783" strokeWidth="2" />
      <line x1="10" y1="14" x2="10" y2="6" stroke="#427783" strokeWidth="2" />
    </g>
    <defs>
      <clipPath id="clip0_22_1322">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ZoomOutIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_22_1321)">
      <circle cx="10" cy="10" r="7" stroke="#427783" strokeWidth="2" />
      <line
        x1="15.4142"
        y1="16"
        x2="18.25"
        y2="18.8358"
        stroke="#427783"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line x1="6" y1="10" x2="14" y2="10" stroke="#427783" strokeWidth="2" />
    </g>
    <defs>
      <clipPath id="clip0_22_1321">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
